// Team / "Quiénes somos" data — current state (iter 9):
//   • Order: Directiva → Cuerpo técnico → Staff (Pablo first, Fernando, then rest)
//   • Members without a real photo yet (noPhoto:true) render as solid blue tiles.
//   • Gonzalo (Founder) is rendered at the END of the page.

export const TEAM_FEATURED = {
  name: "Gonzalo Castro",
  role: "Fundador · Socio gerente",
  photo:
    "https://customer-assets.emergentagent.com/job_barcelona-club-hub/artifacts/y77w49js_image.png",
  bio:
    "Desde el primer día entendí que para progresar en tu vida personal, profesional y social, las cosas siempre se tienen que hacer con esfuerzo, dedicación, compromiso y trabajo: la bandera de un proyecto que es un sueño hecho realidad. Dar la posibilidad a las personas de encontrar un lugar donde, a través del deporte, puedan pertenecer a un grupo humano para compartir pasiones, momentos, amistades — el fruto cosechado de nuestros valores. El mejor premio que puedo obtener a tanto tiempo invertido es ver a los demás felices por pertenecer a La Bombonera.",
};

export const TEAM_MEMBERS = [
  // ─── Directiva ──────────────────────────────────────────
  {
    slug: "fidel-castro",
    name: "Fidel Castro",
    role: "Presidente",
    group: "Directiva",
    photo:
      "https://framerusercontent.com/images/oq1n5S8JoupcmwZlNEyW6x0wQ9w.png?width=600",
  },
  {
    slug: "luis-axcel-gutarra",
    name: "Luis Axcel Gutarra",
    role: "Vicepresidente",
    group: "Directiva",
    photo:
      "https://framerusercontent.com/images/OfBMBPefQMWOtDqOMajPtDqNDY.png?width=600",
  },

  // ─── Cuerpo técnico ─────────────────────────────────────
  {
    slug: "lito",
    name: "Lito",
    role: "Entrenador",
    group: "Cuerpo técnico",
    photo:
      "https://framerusercontent.com/images/b7NH5ZRytA0ylEEWJ8Fa3kWf8Y.png?width=600",
  },
  {
    slug: "david",
    name: "David",
    role: "2º Entrenador",
    group: "Cuerpo técnico",
    photo:
      "https://customer-assets.emergentagent.com/job_barcelona-club-hub/artifacts/8kxxfdto_David.jpeg",
  },

  // ─── Staff (Pablo, Fernando, y el resto) ────────────────
  {
    slug: "pablo-escobar",
    name: "Pablo Escobar",
    role: "Staff",
    group: "Staff",
    photo:
      "https://framerusercontent.com/images/oibS3se7W8D8IBHQ4NoWkLlHU.png?width=600",
  },
  {
    slug: "fernando-guacanoma",
    name: "Fernando Guacanoma",
    role: "Staff",
    group: "Staff",
    photo:
      "https://framerusercontent.com/images/CCheLTy83WCrKaPD1Ox1gTok.png?width=600",
  },
  {
    slug: "ruben",
    name: "Ruben",
    role: "Staff",
    group: "Staff",
    photo:
      "https://customer-assets.emergentagent.com/job_barcelona-club-hub/artifacts/a2u8j3lr_Ruben.jpeg",
  },
  {
    slug: "mauro",
    name: "Mauro",
    role: "Staff",
    group: "Staff",
    photo:
      "https://customer-assets.emergentagent.com/job_barcelona-club-hub/artifacts/sk4awq5i_Mauro.jpeg",
  },
  {
    slug: "andres",
    name: "Andrés",
    role: "Staff",
    group: "Staff",
    photo:
      "https://customer-assets.emergentagent.com/job_barcelona-club-hub/artifacts/hzhi1irw_Andres.jpeg",
  },
];
